import { Box } from '@mui/material';
import { FC, useCallback, useState } from 'react';
import { useCommunications } from '../../../../../../hooks/use-communications';
import { AutomatedMessage } from '../../../../../../hooks/use-communications/types/automated-message';
import { ManagedCommItem } from '../../../../../../hooks/use-communications/types/managed-communication';
import { CommunicationCardFactory } from '../../communcation-card-factory';
import { ManagedCommCardTitle } from '../shared/title/managed-comm-card-title';
import { ManagedCommCard, ManagedCommCardWrapper, ManagedCommSignature } from '../styles';

interface SmsManagedCommCardProps {
  communication: ManagedCommItem;
}

export const SmsManagedCommCard: FC<SmsManagedCommCardProps> = (props) => {
  const { communication } = props;
  const { automatedMessages, data } = useCommunications();
  const [expanded, setExpanded] = useState(false);
  const [autoMessage, setAutoMessage] = useState<AutomatedMessage>();

  const handleExpandClick = useCallback(async () => {
    if (!automatedMessages || !communication.communicationId) return;

    const message = automatedMessages.find(
      (item) =>
        item.message.communicationId &&
        item.message.communicationId.toLowerCase() === communication.communicationId.toLocaleLowerCase()
    );

    if (!message) return;

    setExpanded(true);
    setAutoMessage(message);
  }, [automatedMessages, communication]);

  const handleCollapseClick = async () => {
    setExpanded(false);
    setAutoMessage(undefined);
  };

  return (
    <ManagedCommCardWrapper>
      <ManagedCommCard {...(expanded ? { sx: { backgroundColor: 'white', border: 'none' } } : {})}>
        <ManagedCommCardTitle
          communication={communication}
          onExpand={handleExpandClick}
          onCollapse={handleCollapseClick}
        />
      </ManagedCommCard>
      {!expanded && <ManagedCommSignature communication={communication} />}
      {expanded && autoMessage && (
        <>
          <Box sx={{ display: 'flex', marginTop: '6px' }}>
            <CommunicationCardFactory item={autoMessage.message} />
          </Box>
          {autoMessage.reply && (
            <Box sx={{ display: 'flex', marginTop: '6px' }}>
              <CommunicationCardFactory item={autoMessage.reply} />
            </Box>
          )}
        </>
      )}
    </ManagedCommCardWrapper>
  );
};
